export default ({ request }) => ({
  masterCustomerCostSectorListApi(data) {
    return request({
      url: '/digitalCenter/master/customer/cost/sector/list',
      method: 'POST',
      data,
    })
  },
  masterCustomerCostSectorDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/cost/sector/detail',
      method: 'POST',
      data,
    })
  },
  masterCustomerCostSectorAddApi(data) {
    return request({
      url: '/digitalCenter/master/customer/cost/sector/add',
      method: 'POST',
      data,
    })
  },
  masterCustomerCostSectorDelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/cost/sector/del',
      method: 'POST',
      data,
    })
  },
})
